import React from 'react';
import ReactTooltip from 'react-tooltip';
import ReactDOMServer from 'react-dom/server';
import { withSegmentColors } from './stackBarColors';

const tooltipWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.2rem',
};

const tooltipStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderWeight: '1px',
  borderColor: 'white',
  gap: '2rem',
};

const tooltipColorStyle = {
  width: '10px',
  height: '10px',
  borderRadius: '2px',
};

const tooltipLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
};

const StackBar = ({ segments: rawSegments, height = 10, showLegend = true, tooltipTitle }) => {
  const segments = withSegmentColors(rawSegments);
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  if (total === 0) return null;

  return (
    <React.Fragment>
      <div className="stack-bar">
        <ReactTooltip />
        <div
          className="stack-bar__track"
          style={{ height, borderRadius: height / 2, display: 'flex', overflow: 'hidden' }}
          data-html={true}
          data-tip={ReactDOMServer.renderToString(
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <p style={{ margin: '0px', fontWeight: 'bold' }}>{tooltipTitle}</p>
              <div style={tooltipWrapperStyle}>
                {segments.map((segment, index) => {
                  return (
                    <div key={index} style={{ ...tooltipStyle, borderWeight: '1px', borderColor: 'white' }}>
                      <div style={tooltipLabelStyle}>
                        <span style={{ ...tooltipColorStyle, backgroundColor: segment.color }}></span>
                        <p style={{ margin: '0px' }}>{segment.label}</p>
                      </div>
                      <p style={{ margin: '0', fontWeight: 'bold' }}>{segment.value}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        >
          {segments.map((seg, i) => (
            <div
              key={i}
              title={`${seg.label}: ${seg.value}`}
              style={{
                flex: seg.value,
                background: seg.color,
              }}
            />
          ))}
        </div>
        {showLegend && (
          <div className="stack-bar__legend">
            {segments.map((seg, i) => (
              <span key={i} className="stack-bar__legend-item">
                <span className="stack-bar__swatch" style={{ background: seg.color }} />
                {seg.label}
                <span className="stack-bar__count">{seg.value}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default StackBar;
